<template>
    <section>
      <header class="toolbar u-pl-0 u-pr-0">
        <div class="toolbar__group l-level">
          <div class="l-level__left">
            <c-nav type="pills">
              <c-nav-item 
                v-for="button in settings.filterButtons" 
                :key="button.title" 
                :title="button.title" 
                :active="button.filter_rule==selectedTopFilter"
                @click="setTopFilter(button.filter_rule)"
                ></c-nav-item>
            </c-nav>
          </div>
          <div class="l-level__right" v-if="this.settings.search_by">
            <c-form-input icon-end="icon-search" placeholder="Search..." v-model="queryData.search_value"></c-form-input>
          </div>
        </div>
      </header>
      <table class="table table--bordered table--hover table--responsive">
        <thead>
          <tr>
            <th v-for="col in settings.cols" :key="col.name">
                <a role="button" v-if="col.sortable" @click="proceedSort(col)">
                    {{col.title}}
                    <i :class="Object.keys(queryData.order)[0] == col.name && queryData.order[Object.keys(queryData.order)[0]] == -1 ? 'is-down' : 
                    (Object.keys(queryData.order)[0] == col.name && queryData.order[Object.keys(queryData.order)[0]] == 1 ? 'is-up' : '')"
                    class="i-sort"></i>
                </a>
                <a v-else>
                    {{col.title}}
                </a>
            </th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th v-for="col in settings.cols" :key="col.name">
              {{col.title}}
            </th>
          </tr>
        </tfoot>
        <tbody>
            <tr v-for="row in data" :key="row.id" :data-id="row._id">
                <td v-for="col in settings.cols" :key="col.name" :width="col.width ? col.width : ''">
                    <span v-if="col.type == 'template'" v-html="col.template" />
                    <span v-if="col.type == 'render'" v-html="col.render.apply(settings.scope, [row, col])" />
                    <span v-else-if="col.type == 'datetime'" v-html="formatDateTime(row[col.name])" />
                    <span v-else-if="col.type == 'link'">
                        <router-link :to="col.link.replace(':id', row._id)">{{row[col.name]}}</router-link>
                    </span>
                    <div v-else-if="col.type == 'checkbox'" :style="col.style ? col.style : ''">
                        <c-form-checkbox :checked="row[col.name]" :disabled="true"></c-form-checkbox>
                    </div>
                    <span v-else>
                    {{row[col.name]}}
                    </span>
                </td>
            </tr>
        </tbody>
      </table>
      <footer class="l-level u-mt-30">
        <div class="l-level__right">
          <c-pagination type="bordered" :pager="true" :jumper="true" :total="totalPages" v-model="queryData.skip"></c-pagination>
        </div>
      </footer>


    </section>
</template>

<script>
import moment from "moment";

export default {
    name: 'DataTable',
    props: ['settings'],
    data() {
        return {
            data: [],
            
            totalPages: 0,

            queryData: {
                query: {},
                skip: 1,
                limit: this.settings.limit != null ? this.settings.limit : 50,
                order: this.settings.order_by,
                search_by: this.settings.search_by,
                search_value: null,
                params: this.settings.params
            },

            selectedTopFilter: typeof(this.settings.filterButtons) != "undefined" ? this.settings.filterButtons[0].filter_rule : null
        }
    },
    created() {

        this.getTableData();

    },

    updated() {

        const that   = this;
        const el    = that.$refs.table;

        const elms = document.querySelectorAll('[data-action]'); 

        elms.forEach(function(item, i, arr) {

            item.addEventListener('click', function(eventObj) {

                eventObj.preventDefault();
                eventObj.stopPropagation();

                let action = eventObj.currentTarget.getAttribute('data-action');
                let key = eventObj.currentTarget.closest('tr').getAttribute('data-id');

                that.$emit(action, key);

            });

        });

    },

    computed: {
        getSkip() {
            return this.queryData.skip;
        },
        getSearchValue() {
            return this.queryData.search_value;
        }
    },

    watch: {
        getSkip(newVal){
            this.refresh();
        },
        getSearchValue(newVal){
            this.refresh();
        }
        
    },

    methods: {
        formatDateTime(date) {
            return date ? moment(date).format("YYYY-MM-DD HH:mm") : 'Not set';
        },
        setTopFilter: function(rule) {
            this.selectedTopFilter = rule;           

            this.refresh();

        },
        refresh: function() {
            
            this.getTableData();

        },
        getTableData: function(){

            const _this = this;

             Object.assign(_this.queryData.query, JSON.parse(this.selectedTopFilter));

            _this.$axios.post(_this.settings.dataUrl, _this.queryData)
            .then(response => {

                if(response.status == 200){
                    _this.totalPages = Math.ceil( Number(response.data.data.count/_this.queryData.limit) );
                    _this.data = response.data.data.response;
                }

            })
            .catch(err => {


            });

        },
        proceedSort: function(col) {

            //If col is same
            if(Object.keys(this.queryData.order)[0] == col.name){
                this.queryData.order[Object.keys(this.queryData.order)[0]] *= -1;
            }else{
                this.queryData.order = {};
                this.queryData.order[col.name] = 1;
            }
            
            this.refresh();
        }
    }

}
</script>